import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ChecklistTemplateEditor } from '@/components/ChecklistTemplateEditor'
import { STARTER_CHECKLIST_TEMPLATES } from '@/lib/starter-checklist-templates'

const searchSchema = z.object({
  starter: z.string().optional(),
})

export const Route = createFileRoute('/_auth/operations/checklisttemplates/new')({
  validateSearch: searchSchema,
  component: NewTemplateRoute,
})

function NewTemplateRoute() {
  const { starter } = Route.useSearch()

  const starterDef = starter
    ? STARTER_CHECKLIST_TEMPLATES.find((s) => s.slug === starter)
    : undefined

  return <ChecklistTemplateEditor mode="create" starterDef={starterDef} />
}
